import {NgForm, FormGroup, FormControl, FormArray, Validators} from '@angular/forms';

let _ : any = require("lodash");

export class BaseComponent {
    protected updateValueAndValidity(form: FormGroup) {
        for(let controlName in form.controls) {
            form.controls[controlName].updateValueAndValidity();
        }
    }

    protected touchFormGroup(form: FormGroup) {
        for(let controlName in form.controls) {
            form.controls[controlName].markAsTouched();
            //This is not good because it triggers asynchronous validation and moved FormGroup into pending state (INVALID).
            //form.controls[controlName].updateValueAndValidity();
        }
    }

    protected untouchFormGroup(form: FormGroup) {
        for(let controlName in form.controls) {
            form.controls[controlName].markAsUntouched();
        }
    }

    protected initFormGroup(form: FormGroup, data: any) {
        for(var key in form.controls) {
            if(form.controls[key] instanceof FormControl) {
                if(!_.isUndefined(data[key])){
                    let control = <FormControl>form.controls[key];
                    this.initFormControl(control,data[key]);
                }
            } else if(form.controls[key] instanceof FormGroup) {
                if(!_.isUndefined(data[key])){
                    this.initFormGroup(<FormGroup>form.controls[key],data[key]);
                }
            } else if(form.controls[key] instanceof FormArray) {
                var control = <FormArray>form.controls[key];
                if(!_.isUndefined(data[key]))
                    this.initFormArray(control, data[key]);
            }
        }
    }

    protected initFormArray(array: FormArray, data: Array<any>){
        if(data.length>0){
            var clone = array.controls[0];
            array.removeAt(0);
            for(var idx in data) {
                array.push(_.cloneDeep(clone));
                if(clone instanceof FormGroup)
                    this.initFormGroup(<FormGroup>array.controls[idx], data[idx]);
                else if(clone instanceof FormControl)
                    this.initFormControl(<FormControl>array.controls[idx], data[idx]);
                else if(clone instanceof FormArray)
                    this.initFormArray(<FormArray>array.controls[idx], data[idx]);
            }
        }
    }

    protected initFormControl(control: FormControl, value:any){
        control.setValue(value);
    }
}
